module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TgsNqr/tc-custom/9781638297666.jpg?1674914705167",
      "alt": "This image is the cover for the book Darwin Was Right"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Darwin Was Right\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Beautiful and brilliant FBI Supervisory Agent Emmanuelle Blanchet, known as Emmie to friends and family, was embroiled in the most difficult and challenging case of her life. She and her dedicated team were rushing against time to find and stop a serial killer before he found his next victim. Making the task even more daunting, evidence was piling up suggesting that these murders were somehow related to a cold case that her father had been involved in, and solved, 30 years ago. When one of the victim’s mutilated body is found in the Shenandoah National Park, Emmie encounters National Park Ranger Chief Joel McNeil. The attraction was mutual and intense.  But could she risk getting involved in a romance during an investigation? With her focus being primarily on her career, personal relationships were always put on hold. Would she be able to resist her powerful feelings? As Joel and her team work closely with her against time to find the killer, it becomes clear that she herself may be a target. Will they be able to find the killer before it is too late? Or will it be, as Darwin suggested, the survival of the fittest?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Denise Harrison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "margin-bottom": ".0001pt",
      "text-align": "justify",
      "font-size": "15px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black",
      "background": "white"
    }
  }, [_vm._v("Dee Harrison-Schultz is a licensed clinical counselor for the past 25 years. She is experienced in working with a variety of disorders, within the prison system, as well as in an outpatient setting. These experiences sparked an intense curiosity in forensics and criminology. "), _c('em', [_vm._v("Darwin Was Right")]), _vm._v(" is her premier novel. She lives with her husband, David Schultz, and their two rescue dogs, Zeke and Zoe. They currently divide their time between Spruce Pine, North Carolina, and Punta Gorda, Florida.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0